module.exports = __webpack_public_path__ + "e45eb9530d84f3de49820b87b155325a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Balzano.svg?v=1.00
// module id = 938
// module chunks = 24